module.exports = __webpack_public_path__ + "img/dashboard-icon.b9db9669.svg";